import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withKeys as _withKeys } from "vue";
const _hoisted_1 = { class: "grey lighten-5 px-4 py-4" };
const _hoisted_2 = { class: "require-field-wrapper pb-4" };
const _hoisted_3 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_DialogHeader = _resolveComponent("DialogHeader");
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_v_card = _resolveComponent("v-card");
    const _component_v_select = _resolveComponent("v-select");
    const _component_v_text_field = _resolveComponent("v-text-field");
    const _component_v_form = _resolveComponent("v-form");
    const _component_DialogFooter = _resolveComponent("DialogFooter");
    const _component_v_dialog = _resolveComponent("v-dialog");
    const _component_OrderDetailBaromoneyRemittanceConfirm = _resolveComponent("OrderDetailBaromoneyRemittanceConfirm");
    const _component_OrderDetailBaromoneyRemittanceComplete = _resolveComponent("OrderDetailBaromoneyRemittanceComplete");
    const _directive_ui_permission = _resolveDirective("ui-permission");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_v_dialog, {
            modelValue: _ctx.inProgressDialogOpen,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.inProgressDialogOpen) = $event)),
            "content-class": "responsive-dialog",
            "onClick:outside": _ctx.handleClickCancelInProgress,
            onKeydown: _withKeys(_ctx.handleClickCancelInProgress, ["esc"])
        }, {
            activator: _withCtx(({ props }) => [
                _withDirectives((_openBlock(), _createBlock(_component_v_btn, _mergeProps(props, {
                    class: "btn-outlined-basic",
                    variant: "outlined",
                    height: "40",
                    width: "100%"
                }), {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('views.baromoney.cash_remittance')), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)), [
                    [_directive_ui_permission, [
                            _ctx.userPermission.P_REMITTANCE_BAROMONEY_TO_STORE,
                        ]]
                ])
            ]),
            default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_DialogHeader, {
                            title: _ctx.$t(`${_ctx.lc}baromoney_remittance`),
                            "on-cancel": _ctx.handleClickCancelInProgress
                        }, null, 8 /* PROPS */, ["title", "on-cancel"]),
                        _createVNode(_component_v_card, {
                            flat: "",
                            tile: "",
                            class: "grey lighten-4"
                        }, {
                            default: _withCtx(() => [
                                _createCommentVNode(" 배달번호 "),
                                _createVNode(_component_v_card_title, { class: "text-subtitle-2 brg-color-grey-600 pb-0" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('views.order_detail.order_detail_delivery_info.delivery_id')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_card_title, { class: "text-body-1 pt-2" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.deliveryId), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_divider)
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createVNode(_component_v_form, {
                                    ref: "form",
                                    modelValue: _ctx.valid,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.valid) = $event))
                                }, {
                                    default: _withCtx(() => [
                                        _createCommentVNode(" 보내는 이 "),
                                        _createVNode(_component_v_card_title, { class: "text-subtitle-2 brg-color-grey-600 pb-0" }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.lc}senderName`)), 1 /* TEXT */),
                                                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-red" }, "*", -1 /* CACHED */))
                                            ]),
                                            _: 1 /* STABLE */,
                                            __: [9]
                                        }),
                                        _createVNode(_component_v_select, {
                                            "item-title": "text",
                                            "item-value": "value",
                                            modelValue: _ctx.senderNameOption,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.senderNameOption) = $event)),
                                            items: _ctx.senderNameOptionItems,
                                            density: "compact",
                                            variant: "outlined",
                                            dense: "",
                                            "hide-details": "",
                                            class: "px-4 pt-2",
                                            filled: "",
                                            disabled: ""
                                        }, null, 8 /* PROPS */, ["modelValue", "items"]),
                                        _createCommentVNode(" 송금 가능금액 "),
                                        _createCommentVNode(" TODO 현재 API 가 없는 상황이라, 총판계정일 때 일단 출금가능금액을 히든시키는 방향으로 진행 https://github.com/barogo/zoo/issues/4920#issuecomment-1294469370 "),
                                        (!_ctx.isDistUser)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                                _createVNode(_component_v_card_title, { class: "text-subtitle-2 brg-color-grey-600 pb-0" }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}available_withdrawal_baromoney`)), 1 /* TEXT */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }),
                                                _createVNode(_component_v_card_title, { class: "text-body-1 pt-2 pb-0" }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.withdrawableBaromoney), 1 /* TEXT */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                })
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createCommentVNode(" 받는 이 "),
                                        _createVNode(_component_v_card_title, { class: "text-subtitle-2 brg-color-grey-600 pb-0" }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.lc}receiverName`)), 1 /* TEXT */),
                                                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-red" }, "*", -1 /* CACHED */))
                                            ]),
                                            _: 1 /* STABLE */,
                                            __: [10]
                                        }),
                                        _createVNode(_component_v_select, {
                                            "item-title": "text",
                                            "item-value": "value",
                                            density: "compact",
                                            modelValue: _ctx.receiverInfo,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.receiverInfo) = $event)),
                                            items: _ctx.receiverItems,
                                            "hide-details": "",
                                            "single-line": "",
                                            variant: "outlined",
                                            dense: "",
                                            class: "px-4 pt-2"
                                        }, null, 8 /* PROPS */, ["modelValue", "items"]),
                                        _createCommentVNode(" 송금 금액 "),
                                        _createVNode(_component_v_card_title, { class: "text-subtitle-2 brg-color-grey-600 pb-0" }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.lc}remittance_baromoney`)), 1 /* TEXT */),
                                                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-red" }, "*", -1 /* CACHED */))
                                            ]),
                                            _: 1 /* STABLE */,
                                            __: [11]
                                        }),
                                        _createVNode(_component_v_text_field, {
                                            modelValue: _ctx.formattedRemittanceBaromoney,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.formattedRemittanceBaromoney) = $event)),
                                            variant: "outlined",
                                            density: "compact",
                                            dense: "",
                                            inputmode: "numeric",
                                            "hide-details": "auto",
                                            "single-line": "",
                                            required: "",
                                            placeholder: _ctx.$t(`common.amount_required`),
                                            suffix: _ctx.$t('common.currency'),
                                            rules: [_ctx.rules.required,
                                                _ctx.rules.remittanceAmountOverRawWithdrawableBaromoney,
                                                _ctx.rules.maximumRemittanceAmount,
                                            ],
                                            "validate-on": "blur",
                                            class: "px-4 pt-2",
                                            onKeyup: _cache[3] || (_cache[3] = ($event) => (_ctx.handleRemittanceBaromoneyInputKeyupEvent($event.key)))
                                        }, null, 8 /* PROPS */, ["modelValue", "placeholder", "suffix", "rules"]),
                                        _createCommentVNode(" 송금 메모 "),
                                        _createVNode(_component_v_card_title, { class: "text-subtitle-2 brg-color-grey-600 pb-0" }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}remittance_memo`)), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                        }),
                                        _createVNode(_component_v_text_field, {
                                            modelValue: _ctx.remittanceMemo,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.remittanceMemo) = $event)),
                                            "single-line": "",
                                            variant: "outlined",
                                            dense: "",
                                            "hide-details": "auto",
                                            "validate-on": "blur",
                                            placeholder: _ctx.$t(`${_ctx.lc}remittance_memo_placeholder`),
                                            rules: [_ctx.rules.maximumMemo],
                                            class: "px-4 pt-2"
                                        }, null, 8 /* PROPS */, ["modelValue", "placeholder", "rules"])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue"])
                            ])
                        ]),
                        _createVNode(_component_v_divider),
                        _createVNode(_component_DialogFooter, {
                            cancel: true,
                            ok: true,
                            "on-cancel": _ctx.handleClickCancelInProgress,
                            "on-ok": _ctx.handleClickOkInProgress
                        }, null, 8 /* PROPS */, ["on-cancel", "on-ok"])
                    ]),
                    _: 1 /* STABLE */
                })
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue", "onClick:outside", "onKeydown"]),
        _createCommentVNode(" 바로머니 송금 확인창 "),
        _createVNode(_component_OrderDetailBaromoneyRemittanceConfirm, {
            modelValue: _ctx.confirmDialogOpen,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.confirmDialogOpen) = $event)),
            receiver: _ctx.receiverInfo.receiverName,
            baromoney: _ctx.formattedRemittanceBaromoney,
            "on-click-cancel": _ctx.handleClickConfirmCancel,
            "on-click-ok": _ctx.handleClickConfirmOk
        }, null, 8 /* PROPS */, ["modelValue", "receiver", "baromoney", "on-click-cancel", "on-click-ok"]),
        _createCommentVNode(" 바로머니 송금 확인 완료창 "),
        _createVNode(_component_OrderDetailBaromoneyRemittanceComplete, {
            modelValue: _ctx.completeDialogOpen,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.completeDialogOpen) = $event)),
            "on-click-ok": _ctx.handleClickCompleteOk
        }, null, 8 /* PROPS */, ["modelValue", "on-click-ok"])
    ]));
}
